/**
 * Admin V3 — Top bar
 *
 * Visual: verbatim from AdminDashboard.js:137-166 (gradient blue header).
 * Two structural differences from legacy:
 *   1. No "Control Tower" cyan button (Operations module replaces it).
 *   2. Subtitle is "Administration" (no "(aperçu)" preview tag — V3 is
 *      the target architecture, not a preview).
 *
 * All Tailwind class strings come from the legacy source or its M1
 * inheritor (components/adminv2/AdminV2TopBar.js).
 */

import React from 'react';
import { Mail, Bell, ChevronDown, LogOut } from 'lucide-react';
import { Button } from '../../components/ui/button';
import { t } from '../i18n';

const AdminV3TopBar = ({ userName, onLogout, locale = 'fr' }) => (
  <header className="sticky top-0 z-40 border-b border-white/10 bg-[radial-gradient(circle_at_top,#1d2550_0%,#131a34_35%,#0f172a_100%)] text-white">
    <div className="mx-auto max-w-[1480px] px-6">
      <div className="flex min-h-[72px] items-center gap-4">
        <div className="min-w-fit">
          <div className="text-[18px] font-bold tracking-tight md:text-[20px]">
            {t('admin.title', locale)}
          </div>
          <div className="text-[10px] uppercase tracking-[0.28em] text-slate-400">
            {t('admin.subtitle', locale)}
          </div>
        </div>

        <div className="ml-auto flex items-center gap-2 md:gap-3">
          <button className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-white transition hover:bg-white/10">
            <Mail className="h-4 w-4" />
          </button>
          <button className="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-white transition hover:bg-white/10">
            <Bell className="h-4 w-4" />
          </button>
          <div className="hidden items-center gap-3 rounded-xl border border-white/10 bg-white/5 px-3 py-2 md:flex">
            <div className="flex h-9 w-9 items-center justify-center rounded-full bg-white/15 text-sm font-semibold">
              {userName?.[0]?.toUpperCase() || 'A'}
            </div>
            <div className="leading-tight">
              <div className="text-sm font-medium">{t('admin.user.role', locale)}</div>
              <div className="text-xs text-slate-400">{userName || 'Admin'}</div>
            </div>
            <ChevronDown className="h-4 w-4 text-slate-400" />
          </div>
          <Button
            variant="outline"
            onClick={onLogout}
            className="h-10 rounded-xl border-white/10 bg-white/5 text-white hover:bg-white/10"
            data-testid="adminv3-logout-btn"
          >
            <LogOut className="mr-2 h-4 w-4" />
            {t('admin.button.logout', locale)}
          </Button>
        </div>
      </div>
    </div>
  </header>
);

export default AdminV3TopBar;
